import SEO from '../components/SEO';

export default function Privacy() {
  return (
    <>
      <SEO title="Privacy Policy | Laraé Logistics" description="How Laraé Logistics handles personal data — your rights, what we collect, and how we use it." />
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-5 md:px-8 lg:px-12">
          <h1 className="font-outfit text-4xl md:text-5xl font-medium text-ink tracking-tight">Privacy Policy</h1>
          <p className="font-manrope text-sm text-ink/55 mt-2">Last updated: January 2026</p>
          <div className="prose mt-8 font-manrope text-base text-ink/75 leading-relaxed space-y-4">
            <p>Laraé Logistics ("we", "us") respects your privacy. This policy explains what data we collect, how we use it and the rights you have under UK GDPR.</p>
            <h2 className="font-outfit text-xl font-semibold text-ink mt-8">Data we collect</h2>
            <p>When you submit a quote request or contact form we collect your name, phone, email, addresses, and any photos or notes you provide. We do not collect this data unless you submit it voluntarily.</p>
            <h2 className="font-outfit text-xl font-semibold text-ink mt-8">How we use your data</h2>
            <p>To provide you with a quote, to arrange and deliver your move, and to contact you about your enquiry. We do not sell or share your data with marketers.</p>
            <h2 className="font-outfit text-xl font-semibold text-ink mt-8">How long we keep it</h2>
            <p>We hold enquiry data for up to 24 months. Booking records are kept for 6 years for tax and insurance purposes, then deleted.</p>
            <h2 className="font-outfit text-xl font-semibold text-ink mt-8">Your rights</h2>
            <p>You can request a copy of your data, ask us to correct it, or ask us to delete it at any time by emailing laraelogistics24@gmail.com.</p>
            <h2 className="font-outfit text-xl font-semibold text-ink mt-8">Cookies</h2>
            <p>We use essential cookies to make the site work and minimal analytics cookies to improve it. You can decline non-essential cookies via the banner.</p>
          </div>
        </div>
      </section>
    </>
  );
}
